import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { PurchaseHistoryEffects } from './purchase-history.effects';
import { IPurchaseHistoryFeature } from './purchase-history.feature.state';
import { purchaseHistoryReducer } from './purchase-history.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IPurchaseHistoryFeature>('purchaseHistoryFeature'), purchaseHistoryReducer),
    EffectsModule.forFeature([PurchaseHistoryEffects]),
  ],
})
export class PurchaseHistoryStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: PurchaseHistoryStateModule
  ) {
    if (parentModule) {
      throw new Error('PurchaseHistoryStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
